import React from "react"
import autobind from "class-autobind"
import moment from "moment"
import { IDate, ActiveTimeButton, ITimecardDates, IPayGroup, EDayOfWeek, IPayrollPayCalendar } from "../../models"
import DateRangeSelect from "./DateRangeSelect"
import { RaisedButton } from "material-ui"
import strings from "../../localization/strings"
import * as timeHelper from "../../helpers/timeHelper"
import * as timecardHelper from "../../helpers/timecardHelper"
interface IProps {
    // these datetime should be utc format
    startDate: IDate
    endDate: IDate
    sameDatesAllowed?: boolean
    timeLabel?: boolean
    spaceBetween?: number
    datePickerWidth?: number
    readonly?: boolean

    // should set selectedPayGroup or selectedPayrollPayCalendar
    selectedPayGroup?: IPayGroup
    selectedPayrollPayCalendar?: IPayrollPayCalendar
    handleChange(startDate: IDate, endDate: IDate, isValid: boolean): void
}
interface IState {
    startDate: IDate
    errorStartDate: string
    endDate: IDate
    errorEndDate: string
}

export default class DateRangeSelect_SelectWeek extends React.Component<IProps, IState> {
    private ThisWeekDates: ITimecardDates; LastWeekDates: ITimecardDates; startDayOfWeek: EDayOfWeek
    constructor(props: IProps) {
        super(props)
        this.ThisWeekDates = props.selectedPayGroup ?
            timecardHelper.getTimecardDateByPayGroupId(moment(), props.selectedPayGroup.Id) :
            timecardHelper.getTimecardDateByPayrollPayCalendar(moment(), props.selectedPayrollPayCalendar)
        this.ThisWeekDates.StartDate = moment(this.ThisWeekDates.StartDate).utc(true).format()
        this.ThisWeekDates.EndDate = moment(this.ThisWeekDates.EndDate).utc(true).format()
        this.LastWeekDates = props.selectedPayGroup ?
            timecardHelper.getTimecardDateByPayGroupId(moment().add(-1, "week"), props.selectedPayGroup.Id) :
            timecardHelper.getTimecardDateByPayrollPayCalendar(moment().add(-1, "week"), props.selectedPayrollPayCalendar)
        this.LastWeekDates.StartDate = moment(this.LastWeekDates.StartDate).utc(true).format()
        this.LastWeekDates.EndDate = moment(this.LastWeekDates.EndDate).utc(true).format()
        this.startDayOfWeek = props.selectedPayGroup ?
            props.selectedPayGroup.PaySettings.PayPeriodStartDay :
            props.selectedPayrollPayCalendar.PayPeriodStartDay

        this.state = {
            startDate: props.startDate,
            errorStartDate: "",
            endDate: props.endDate,
            errorEndDate: "",
        }
        autobind(this)
    }

    componentWillReceiveProps(nextProps: IProps) {
        !(moment(this.props.startDate).isSame(nextProps.startDate) && moment(this.props.endDate).isSame(nextProps.endDate)) &&
            this.setState({
                startDate: nextProps.startDate,
                endDate: nextProps.endDate
            })
    }

    handleChange(startDate: IDate, endDate: IDate, isValid: boolean) {
        this.props.handleChange(startDate, endDate, isValid)
    }

    handleWeekChange(referenceDate: IDate) {
        const scheduleWeek = timeHelper.getWeekRange(this.startDayOfWeek, moment(referenceDate).format())
        const startDate = moment(scheduleWeek.startDate).utc(true).format()
        const endDate = moment(scheduleWeek.endDate).utc(true).format()
        this.setState({ startDate, endDate })
        this.handleChange(startDate, endDate, true)
    }

    getStyleLabel(_button: ActiveTimeButton) {
        return this.buttonIsActive(_button) ? Object.assign({}, styles.label, styles.activeLabel) : styles.label
    }

    getStyleBtn(_button: ActiveTimeButton) {
        return this.buttonIsActive(_button) ? Object.assign({}, styles.btn, styles.activeBtn) : styles.btn
    }

    buttonIsActive(_button: ActiveTimeButton): boolean {
        let active = false
        switch (_button) {
            case "this":
                active = this.state.startDate === this.ThisWeekDates.StartDate && this.state.endDate === this.ThisWeekDates.EndDate
                break
            case "last":
                active = this.state.startDate === this.LastWeekDates.StartDate && this.state.endDate === this.LastWeekDates.EndDate
                break
        }
        return active
    }


    render() {
        return (
            <div style={{ display: "flex" }}>
                <DateRangeSelect
                    startDate={this.state.startDate}
                    endDate={this.state.endDate}
                    sameDatesAllowed={this.props.sameDatesAllowed}
                    timeLabel={this.props.timeLabel}
                    spaceBetween={this.props.spaceBetween}
                    datePickerWidth={this.props.datePickerWidth}
                    readonly={this.props.readonly}
                    handleChange={this.props.handleChange}
                />
                <div style={{ marginLeft: 30, marginTop: 27 }}>
                    <i
                        className="fa fa-arrow-circle-left TimeActionBarArrow"
                        style={{ marginRight: 10 }}
                        onClick={() => this.handleWeekChange(moment(this.state.startDate).subtract(1, "week").toDate())}
                    />
                    <RaisedButton
                        key="last"
                        label={strings.Last_Week.toUpperCase()}
                        style={{ marginRight: 5 }}
                        onTouchTap={() => this.handleWeekChange(moment().subtract(1, "week").toDate())}
                        labelStyle={this.getStyleLabel("last")}
                        buttonStyle={this.getStyleBtn("last")}
                        disabled={this.props.readonly}
                    />
                    <RaisedButton
                        key="this"
                        label={strings.This_Week.toUpperCase()}
                        onTouchTap={() => this.handleWeekChange(new Date())}
                        labelStyle={this.getStyleLabel("this")}
                        buttonStyle={this.getStyleBtn("this")}
                        disabled={this.props.readonly}
                    />
                    <i
                        className="fa fa-arrow-circle-right TimeActionBarArrow"
                        style={{ marginLeft: 10 }}
                        onClick={() => this.handleWeekChange(moment(this.state.startDate).add(1, "week").toDate())}
                    />
                </div>
            </div>
        )
    }
}

const styles = {
    btn: { background: "white" },
    label: { fontSize: "14px" },
    activeBtn: { background: "#A9A9A9" },
    activeLabel: { color: "white" }
}
